export default {"src":"/_next/static/media/career-management.0528d46e.svg","height":644,"width":664,"blurWidth":0,"blurHeight":0};